<template>
  <hr-adaptive-form-dialog
    ref="dialog"
    size="sm"
    :title="$t('editor.image.changeWidth')"
    @close="hide"
  >
    <div class="row q-col-gutter-md">
      <hr-text-field
        ref="widthInput"
        v-model.number="newWidth"
        type="number"
        :label="$t('editor.image.width')"
        :rules="rules"
        clearable
        suffix="px"
        hide-bottom-space
        class="col-12"
      />
    </div>
    <template #actions>
      <hr-confirm-btn
        :label="$t('common.buttonApply')"
        :disable="!isValidWidth"
        @click="onSubmitWidth"
      />
    </template>
  </hr-adaptive-form-dialog>
</template>

<script>
import {
  HrAdaptiveFormDialog,
  HrConfirmBtn,
  HrTextField,
} from 'src/design-system';

export default {
  name: 'EditorResizeImageMobileDialog',

  components: {
    HrAdaptiveFormDialog,
    HrConfirmBtn,
    HrTextField,
  },

  props: {
    width: {
      type: Number,
      required: true,
    },

    minWidth: {
      type: Number,
      required: true,
    },

    maxWidth: {
      type: Number,
      required: true,
    },

    rules: {
      type: Array,
      default() {
        return [];
      },
    },
  },

  emits: ['ok'],

  data() {
    return {
      newWidth: 0,
    };
  },

  computed: {
    isValidWidth() {
      return this.newWidth >= this.minWidth && this.newWidth <= this.maxWidth;
    }, // isValidWidth()
  },

  created() {
    this.newWidth = this.width;
  },

  methods: {
    // following method is REQUIRED
    // (don't change its name --> "show")
    show() {
      this.$refs.dialog.show();
    },

    // following method is REQUIRED
    // (don't change its name --> "hide")
    hide() {
      if (this.$refs.dialog) {
        this.$refs.dialog.hide();
      }
    },

    async onSubmitWidth() {
      this.$emit('ok', this.newWidth);
      this.hide();
    }, // onSubmitForm()
  },
};
</script>
